/* ==========================================================================
   Our Story — custom play overlay
   Ships as: assets/event-story.js  (loaded with defer)

   Without JS the video keeps its native controls and works normally. With JS
   we hide those controls so the poster reads as a clean still, show one large
   play button, then hand control back to the browser on first play.
   ========================================================================== */

(function () {
  'use strict';

  var player = document.querySelector('.event-story__player');
  if (!player) return;

  var video = player.querySelector('video');
  var button = player.querySelector('.event-story__play');
  if (!video || !button) return;

  video.controls = false;
  button.hidden = false;
  player.setAttribute('data-idle', '');

  function start() {
    video.controls = true;
    player.removeAttribute('data-idle');
    button.hidden = true;
    var p = video.play();
    // autoplay policies reject muted-less playback in some contexts
    if (p && typeof p.catch === 'function') {
      p.catch(function () { video.controls = true; });
    }
  }

  button.addEventListener('click', start);

  // if playback starts any other way, get the overlay out of the way
  video.addEventListener('play', function () {
    video.controls = true;
    player.removeAttribute('data-idle');
    button.hidden = true;
  });
})();
